import { FeatureFlag } from '@mode/shared/contract-common';
/**
 * @description Contains the LaunchDarkly feature flags that are relevent to the muze configuration.
 * This map should be populated by the viz-renderer component prior to building the configuration.
 */
export const MuzeFeatureFlags: Record<string, boolean | number> = {
  [FeatureFlag.VizExplorerMaxFacetsPerPage]: 4000,
};

export function getMaxFacetPerPage() {
  return MuzeFeatureFlags[FeatureFlag.VizExplorerMaxFacetsPerPage] as number;
}
